export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f97f5b346c96de87d6149aec14e25003796182442&name=fetchTypeahead!'